module.exports = __webpack_public_path__ + "media/signup-react/yellow-oval-a60cde86.png";